export const mfManifestsPath = '/assets/module-federation.manifest.dev4.json'
